<template>
	<div class="bdmanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">BD管理</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">添加BD</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="width: 350px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">手机号码</span>
								<a-input placeholder="请输入手机号码" style="width: 260px" v-model="add_phone_number" />
							</div>
							<div style="width: 500px;display: inline-block;margin-right: 20px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">负责城市</span>
								<!-- <span>{{citytext}}</span>
								<a-cascader :showSearch="{filter}" changeOnSelect :field-names="{ label: 'value', value: 'value', children: 'children' }" :options="cityoptions" @change="cityChange" style="display: inline-block;float: right;"
								 placeholder="请选择" >
									<a-button type="primary" size="small" ghost style="width: 96px;font-size: 12px;" >选择城市</a-button>
								 </a-cascader> -->
								<a-tree-select multiple :treeData="newcityoptions" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
								 style="width: 400px;" @change="cityChange" tree-checkable :show-checked-strategy="SHOW_PARENT"></a-tree-select>
							</div>
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;" @click="sendbtn">发送邀请码</a-button>
						</div>

					</div>
					<div class="contentcard" style="margin-bottom: 0px;padding-bottom: 70px;">
						<div style="display: flow-root;position: relative;">
							<a-input-search placeholder="搜索BD" style="width: 200px;float: right;margin: -10px 0 10px 0;" @search="onSearchBD" />
						</div>
						<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
							<a-col :span="2" style="text-align: center;">微信昵称</a-col>
							<a-col :span="2" style="text-align: center;">微信头像</a-col>
							<a-col :span="3" style="text-align: center;">手机号码</a-col>
							<a-col :span="4" style="text-align: center;">负责城市</a-col>
							<a-col :span="6" style="text-align: center;">操作</a-col>
						</a-row>
						<div v-if="issearchBD" style="text-align: center;border-radius: 4px;padding: 11px 0 0 0;">
							<a-spin />
						</div>
						<div v-if="(!bdlist.length)&&(!issearchBD)">
							<a-alert message="查询结果为空" banner type="info" />
						</div>
						<div style="color: #666;font-size: 14px;" v-for="(user,index) in bdlist" :key="index">
							<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
								<a-col :span="2" style="text-align: center;">{{user.nick_name}}</a-col>
								<a-col :span="2" style="text-align: center;"><img :src="user.avatar_url" height="56" /></a-col>
								<a-col :span="3" style="text-align: center;">{{user.phone_number}}</a-col>
								<a-col :span="4" style="text-align: center;">
									<!-- <span v-if="user.UIC_BD_Cryptographics.length>0">{{JSON.parse(user.UIC_BD_Cryptographics[0].cities)[0]}}{{JSON.parse(user.UIC_BD_Cryptographics[0].cities).length>1?('、'+JSON.parse(user.UIC_BD_Cryptographics[0].cities)[1]):''}}{{JSON.parse(user.UIC_BD_Cryptographics[0].cities).length>2?('等'):''}}</span> -->

									<a-tooltip placement="topRight" v-if="user.UIC_BD_Cryptographics.length>0">
										<template slot="title" v-if="JSON.parse(user.UIC_BD_Cryptographics[0].cities).length>3">
											<span v-for="(city,cityindex) in JSON.parse(user.UIC_BD_Cryptographics[0].cities)" :key="cityindex">{{city}}
											</span>
										</template>
										<span v-if="user.UIC_BD_Cryptographics.length>0">{{JSON.parse(user.UIC_BD_Cryptographics[0].cities)[0]}}{{JSON.parse(user.UIC_BD_Cryptographics[0].cities).length>1?('、'+JSON.parse(user.UIC_BD_Cryptographics[0].cities)[1]):''}}{{JSON.parse(user.UIC_BD_Cryptographics[0].cities).length>2?('等'):''}}</span>
									</a-tooltip>

									<!-- <a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;">选择城市</a-button> -->
								</a-col>
								<a-col :span="6" style="text-align: center;">
									<div>
										<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;margin-right: 10px;" @click="gotoshopkeeper(user)">查看店主</a-button>
										<a-button size="small" type="danger" ghost disabled style="width: 96px;font-size: 12px;">删除</a-button>
									</div>
								</a-col>
							</a-row>
						</div>
						<div style="float: right;position: relative;bottom: -18px;">
							<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="bdsum"
							 showQuickJumper @change="pageChange" />
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import {
		TreeSelect
	} from 'ant-design-vue';
	const SHOW_PARENT = TreeSelect.SHOW_PARENT;
	export default {

		data() {
			return {
				current: ['bdmanagement'],
				openKeys: ['bdmodule'],
				userlist: null,
				bdlist: [],
				issearch: false,
				issearchBD: false,
				bdsum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				searchvalue: null,
				newcityoptions: require("./areaData.json"),
				citytext: [],
				add_phone_number: null,
				SHOW_PARENT,
			}
		},
		created: function() {
			this.initialize();
		},
		methods: {
			filter(inputValue, path) {
				return (path.some(option => (option.value).indexOf(inputValue) > -1));
			},
			initialize() {
				var self = this;
				this.issearchBD = true;
				this.bdlist = [];
				this.bdsum = 0;
				var params = {
					searchvalue: this.searchvalue,
					startpage: this.startpage,
					pageSize: this.pageSize
				};
				this.$axios.get('/bd/getlist', {
					params: params
				}).then(function(res) {
					self.bdlist = res.data.bdlist;
					self.bdsum = res.data.bdsum;
					self.issearchBD = false;
				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'bdmanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue: this.searchvalue
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'bdmanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue: this.searchvalue
					}
				})
			},
			sendbtn() {
				if (!this.add_phone_number) {
					return this.$message.error("手机号码不能为空");
				}
				if (!this.citytext.length) {
					return this.$message.error("负责城市不能为空");
				}
				var self = this;
				this.issearch = true;
				var params = {
					phone_number: this.add_phone_number,
					cities: JSON.stringify(this.citytext)
				};
				// console.log(params)
				this.$confirm({
					title: '提示',
					content: '是否添加BD',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/bd/addnew', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
						});
					},
					onCancel() {},
				});
			},
			onSearchBD(value) {
				var self = this;
				this.searchvalue = value;
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'bdmanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue: this.searchvalue
					}
				})
			},
			// cityChange(value, selectedOptions) {
			// 	// console.log(value,label)
			// 	this.citytext = selectedOptions.map(o => o.value).join(',');
			// 	// this.product_category_id = label[label.length - 1].value;
			// },
			cityChange(value, label, extra) {
				var data = value;
				// console.log(value)
				// console.log(data)
				this.citytext = [];
				for (var i = 0; i < data.length; i++) {
					if (data[i] == 'all') {
						this.citytext = ['全国'];
						break;
					} else {
						// var site = data[i].splice(0,1);
						// console.log(data[i])
						var province = data[i].slice(0, 2);
						var city = data[i].slice(2, 4);
						var district = data[i].slice(4, 6);
						var text = '';
						var provincesite = 0;
						var citysite = 0;
						for (var pro = 0; pro < this.newcityoptions.length; pro++) {
							if (province == this.newcityoptions[pro].value.slice(0, 2)) {
								text += this.newcityoptions[pro].title;
								provincesite = pro;
								break;
							}
						}
						if (city !== '00') {
							for (var cit = 0; cit < this.newcityoptions[provincesite].children.length; cit++) {
								if (city == this.newcityoptions[provincesite].children[cit].value.slice(2, 4)) {
									text += (" " + this.newcityoptions[provincesite].children[cit].title);
									citysite = cit;
									break;
								}
							}
							if (district !== '00') {
								for (var dis = 0; dis < this.newcityoptions[provincesite].children[cit].children.length; dis++) {
									if (district == this.newcityoptions[provincesite].children[cit].children[dis].value.slice(4, 6)) {
										text += (" " + this.newcityoptions[provincesite].children[cit].children[dis].title);
										break;
									}
								}
							}
						}
						this.citytext.push(text);
					}
				}
				// console.log(JSON.stringify(this.citytext))
			},
			getone(site) {
				return this.newcityoptions[site[0]].title;
			},
			gettwo(site) {
				return this.newcityoptions[site[0]].children[site[1]].title;
			},
			getthree(site) {
				return this.newcityoptions[site[0]].children[site[1]].children[site[2]].title;
			},
			gotoshopkeeper(user) {
				// console.log(user.id)
				this.$router.push({
					name: 'bdinfo',
					query: {
						bd_id: user.id,
					}
				})
			},



		}

	};
</script>

<style>
	.bdmanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?70f5c210